import { useFetchEcompages } from "@/apis/queryFunctions/ecompagesFunctions";
import { Anchor, Box, Checkbox, Text } from "@mantine/core";
import { useRouter } from "next/router";
import React from "react";

function SubmitPrivacy({ checked, setChecked, isFirst, setIsFirst, isCart }) {
  const { locale } = useRouter();

  const { data: cskh } = useFetchEcompages({
    sort: { sst: 1 },
    limit: 5,
    condition: {
      ngon_ngu: locale,
      loai_tin_tuc: "Chính sách khách hàng",
      shared: true,
    },
  });

  const chinh_sach_mua_hang = cskh?.find(
    (item) => item?.slug === "chinh-sach-mua-hang"
  );

  const chinh_sach_bao_mat = cskh?.find(
    (item) => item?.slug === "chinh-sach-bao-mat"
  );

  if (isCart) {
    return null;
  }

  return (
    <Box
      sx={{
        padding: "0 15px",
      }}
    >
      <Checkbox
        value={checked}
        onChange={(e) => {
          if (isFirst === false && e.currentTarget.checked === true) {
            setIsFirst(true);
          } else if (isFirst === true && e.currentTarget.checked === false) {
            setIsFirst(false);
          }

          setChecked(e.currentTarget.checked);
        }}
        label={
          locale === "vi" ? (
            <>
              Tôi đã đọc, hiểu và chấp thuận{" "}
              <Anchor
                href={`/chinh-sach/${chinh_sach_bao_mat?.slug}`}
                target="_blank"
              >
                Chính sách Bảo mật
              </Anchor>{" "}
              và{" "}
              <Anchor
                href={`/chinh-sach/${chinh_sach_mua_hang?.slug}`}
                target="_blank"
              >
                Các Điều khoản dịch vụ
              </Anchor>
              {isFirst === false && checked === false ? (
                <Text color="red" size={12} weight={500}>
                  Vui lòng đòng ý với Chính sách Bảo mật và Các Điều khoản dịch
                  vụ
                </Text>
              ) : null}
            </>
          ) : (
            <>
              I agree to{" "}
              <Anchor href="/chinh-sach/privacy-policy" target="_blank">
                Privacy Policy
              </Anchor>{" "}
              and{" "}
              <Anchor href="/chinh-sach/term-of-service" target="_blank">
                Term of Service
              </Anchor>
              {isFirst === false && checked === false ? (
                <Text color="red" size={12} weight={500}>
                  Please agree to the Privacy Policy and Term of Service
                </Text>
              ) : null}
            </>
          )
        }
        la
      />
    </Box>
  );
}

export default SubmitPrivacy;
